import React from 'react'
import { Button } from 'components/Form'
import { useNavigate } from 'react-router-dom'

/**
 * Loading spinner component
 * @param {Object} props - Component props
 * @param {boolean} props.loading - Loading state
 * @param {Array} props.customers - Customers array
 * @param {Array} props.accountCodes - Account codes array
 * @param {Object} props.globalCompany - Global company object
 * @param {string} props.message - Custom loading message
 */
export const LoadingSpinner = ({ loading, customers, accountCodes, globalCompany, message }) => {
    return (
        <div className="flex items-center justify-center h-64">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
                <p>{message || 'Loading data...'}</p>
                <p className="text-sm text-gray-500 mt-2">
                    {!customers?.length && globalCompany ? 'Loading customers... ' : ''}
                    {!accountCodes?.length && globalCompany ? 'Loading account codes... ' : ''}
                    {loading ? 'Loading companies and configurations...' : ''}
                </p>
            </div>
        </div>
    )
}

/**
 * No companies found component
 */
export const NoCompaniesFound = () => {
    return (
        <div className="flex flex-col items-center justify-center h-64 space-y-4">
            <div className="text-center">
                <h3 className="text-lg font-medium text-gray-900 dark:text-white">No Companies Found</h3>
                <p className="text-gray-500 dark:text-gray-400 mt-2">
                    No companies are available. Please contact your administrator.
                </p>
            </div>
        </div>
    )
}

/**
 * No Xero configuration found component
 * @param {string} id - Invoice ID (for edit mode)
 * @param {Object} recordData - Record data
 */
export const NoXeroConfig = ({ id, recordData }) => {
    const navigate = useNavigate()

    // In edit mode with recordData.configuration_id, we can proceed
    if (id && recordData && recordData.configuration_id) {
        return null
    }

    return (
        <div className="flex flex-col items-center justify-center h-64 space-y-4">
            <div className="text-lg text-red-600">No active Xero configuration found</div>
            <div className="text-sm text-gray-600">
                Please configure Xero integration in Company Management before creating invoices.
            </div>
            <Button
                onClick={() => navigate('/company-management/xero-integration')}
                className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
            >
                Go to Xero Configuration
            </Button>
        </div>
    )
}
